import { render, staticRenderFns } from "./AuctionTermsLink.vue?vue&type=template&id=718567ef&scoped=true"
import script from "./AuctionTermsLink.vue?vue&type=script&lang=js"
export * from "./AuctionTermsLink.vue?vue&type=script&lang=js"
import style0 from "./AuctionTermsLink.vue?vue&type=style&index=0&id=718567ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718567ef",
  null
  
)

export default component.exports